import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext"

export const ProtectRoute = () => {
    const { user, isLoading } = useAuth()
    
    // Show loading while checking auth
    if (isLoading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        )
    }
    
    //  Only redirect after loading is complete
    return user ? <Outlet /> : <Navigate to="/login" replace />
}